export const METODOS_PAGO = {
  "transferencia-bancaria": { value: "transferencia-bancaria", label: "Transferencia Bancaria" },
  "vale-vista": { value: "vale-vista", label: "Vale vista" }
};
